/*
 * NewTreatmentResultStep Messages
 *
 * This contains all the text for the NewTreatmentResultStep container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.NewTreatmentResultStep";

export default defineMessages({
  patient_id: {
    id: `${scope}.patient_id`,
    defaultMessage: "Patient ID.: ",
  },
  treatment: {
    id: `${scope}.treatment`,
    defaultMessage: "Treatment: ",
  },
  treatment_type: {
    id: `${scope}.treatment_type`,
    defaultMessage: "Treatment Type: ",
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: "Date: ",
  },
  time: {
    id: `${scope}.time`,
    defaultMessage: "Time: ",
  },
});
